export const themes = ['default', 'light', 'dark'] as const;
export type Theme = (typeof themes)[number];
